<div class="crud-lyfis-partner-profile" *ngIf="form" [formGroup]="form">
  <nz-card nzTitle="Partner Profile">
    <div class="form-grid">
      <div class="form-item full">
        <label class="font-bold" for="partnerSelect">Partner</label>
        <nz-select
          id="partnerSelect"
          [nzId]="'partnerSelect'"
          style="width: 50%"
          formControlName="partnerId"
          nzPlaceHolder="Select partner"
          nzShowSearch
        >
          <nz-option
            *ngFor="let p of partnerOptions"
            [nzLabel]="p.lable"
            [nzValue]="p.value"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-item switch-item">
        <label class="font-bold" for="activeSwitch">Active</label>
        <nz-switch [nzId]="'activeSwitch'" formControlName="active"></nz-switch>
      </div>

      <div class="form-item full">
        <label class="font-bold" for="enabledDiseases">Enabled Diseases</label>
        <nz-select
          id="enabledDiseases"
          [nzId]="'enabledDiseases'"
          style="width: 50%"
          formControlName="enabledDiseases"
          nzMode="multiple"
          nzPlaceHolder="Select diseases"
          nzShowSearch
        >
          <nz-option
            *ngFor="let o of diseaseOptions"
            [nzLabel]="o.lable"
            [nzValue]="o.value"
          ></nz-option>
        </nz-select>
      </div>

      <!-- <div class="form-item full">
        <label class="font-bold" for="questionBlocks">Question Blocks</label>
        <nz-select
          id="questionBlocks"
          [nzId]="'questionBlocks'"
          style="width: 50%"
          formControlName="questionBlockIds"
          nzMode="multiple"
          nzPlaceHolder="Select blocks"
          nzShowSearch
        >
          <nz-option
            *ngFor="let o of questionBlockOptions"
            [nzLabel]="o.lable"
            [nzValue]="o.value"
          ></nz-option>
        </nz-select>
      </div> -->

      <div class="form-item full">
        <div class="flex justify-between items-center">
          <label class="font-bold">Compiled Artifacts (per disease)</label>
          <button nz-button nzType="default" (click)="addDiseaseArtifactRow()">
            Add mapping
          </button>
        </div>
        <div class="mt-2" *ngIf="!diseaseArtifactRows.length">
          No mappings added. Please add at least one.
        </div>
        <div
          class="artifact-row"
          *ngFor="let row of diseaseArtifactRows; let i = index"
          style="
            display: flex;
            gap: 8px;
            align-items: center;
            margin-bottom: 8px;
          "
        >
          <nz-select
            style="width: 220px"
            [ngModel]="row.diseaseId"
            (ngModelChange)="updateDiseaseArtifact(i, 'diseaseId', $event)"
            [ngModelOptions]="{ standalone: true }"
            nzPlaceHolder="Disease"
            nzShowSearch
          >
            <nz-option
              *ngFor="let o of diseaseOptions"
              [nzLabel]="o.lable"
              [nzValue]="o.value"
            ></nz-option>
          </nz-select>

          <nz-select
            style="width: 500px"
            [ngModel]="row.compiledArtifactId"
            (ngModelChange)="
              updateDiseaseArtifact(i, 'compiledArtifactId', $event)
            "
            [ngModelOptions]="{ standalone: true }"
            nzPlaceHolder="Compiled artifact"
            nzShowSearch
          >
            <nz-option
              *ngFor="let a of artifactsForDisease(row.diseaseId)"
              [nzLabel]="getArtifactDisplayLabel(a)"
              [nzValue]="a.id"
            ></nz-option>
          </nz-select>

          <button nz-button nzType="default" (click)="removeDiseaseArtifact(i)">
            Remove
          </button>
        </div>
      </div>

      <div class="form-item full">
        <label class="font-bold" for="pdhBandsRules">PDH Bands Rules</label>
        <nz-select
          id="pdhBandsRules"
          [nzId]="'pdhBandsRules'"
          style="width: 50%"
          formControlName="pdhBandsRules"
          nzMode="multiple"
          nzPlaceHolder="Select rules"
          nzShowSearch
        >
          <nz-option
            *ngFor="let o of pdhBandsRuleOptions"
            [nzLabel]="o.lable"
            [nzValue]="o.value"
          ></nz-option>
        </nz-select>
        <button
          nz-button
          nzType="default"
          class="ml-2"
          (click)="openRuleViewer('pdhBandsRules')"
        >
          View rule
        </button>
      </div>

      <div class="form-item full">
        <label class="font-bold" for="ghsBandsRules">GHS Bands Rules</label>
        <nz-select
          id="ghsBandsRules"
          [nzId]="'ghsBandsRules'"
          style="width: 50%"
          formControlName="ghsBandsRules"
          nzMode="multiple"
          nzPlaceHolder="Select rules"
          nzShowSearch
        >
          <nz-option
            *ngFor="let o of ghsBandsRuleOptions"
            [nzLabel]="o.lable"
            [nzValue]="o.value"
          ></nz-option>
        </nz-select>
        <button
          nz-button
          nzType="default"
          class="ml-2"
          (click)="openRuleViewer('ghsBandsRules')"
        >
          View rule
        </button>
      </div>
    </div>
  </nz-card>

  <div class="actions">
    <button nz-button nzType="primary" (click)="onSave()">
      {{ form.get("id")?.value ? "Update" : "Save" }}
    </button>
  </div>
</div>

<nz-drawer
  [nzVisible]="drawerVisible"
  [nzTitle]="drawerTitle"
  (nzOnClose)="closeDrawer()"
  [nzWidth]="600"
>
  <ng-container *ngIf="selectedRules.length">
    <div class="space-y-4">
      <div
        *ngFor="let rule of selectedRules"
        class="border border-gray-200 rounded-md p-4"
      >
        <h4 class="font-medium mb-2">{{ rule.name }}</h4>
        <div class="text-sm text-gray-600 mb-1">
          <strong>Type:</strong> {{ rule.type }}
        </div>
        <div class="text-sm text-gray-600 mb-1">
          <strong>ID:</strong> {{ rule.id }}
        </div>
        <div *ngIf="rule.description" class="text-sm mt-2">
          <strong>Description:</strong>
          <p class="mt-1 whitespace-pre-wrap">{{ rule.description }}</p>
        </div>
      </div>
    </div>
  </ng-container>
  <div *ngIf="!selectedRules.length" class="text-gray-500 text-center py-4">
    No rules available
  </div>
</nz-drawer>
